import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import {
  SlotsNextArrow,
  SlotsPrevArrow,
} from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_primitives/slots-pagination-arrows.component';
import { ScheduleSlotsDay } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_hooks/use-schedule-slots.hook';
import { dateFormatter } from '@/utils/formatters/date';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

interface ScheduledDaysHeaderProps {
  days: ScheduleSlotsDay[];
  prevDisabled: boolean;
  nextDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
  today?: Date;
}

export function ScheduledDaysHeader({
  days,
  prevDisabled,
  nextDisabled,
  onPrev,
  onNext,
  today = new Date(),
}: ScheduledDaysHeaderProps) {
  const todayStr = dateFormatter(today, 'YYYY-MM-DD');

  return (
    <div className="flex items-start justify-center w-full">
      <SlotsPrevArrow
        disabled={prevDisabled}
        testId={DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_PREV}
        onClick={onPrev}
      />
      <div className="flex-1 flex gap-4 items-start min-w-0">
        {days.map((day) => {
          const weekday = dateFormatter(day.date, 'YYYY-MM-DD') === todayStr
            ? 'Hoje'
            : formatToTitleCase(dateFormatter(day.date, 'weekday')).replace(/\.$/, '');

          return (
            <div key={day.date} className="flex flex-1 flex-col items-center text-center whitespace-nowrap min-w-0">
              <Typography variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-semibold">
                {weekday}
              </Typography>
              <Typography variant={TypographyVariant.BODY_TEXT}>
                {dateFormatter(day.date, 'DD/MM')}
              </Typography>
            </div>
          );
        })}
      </div>
      <SlotsNextArrow
        disabled={nextDisabled}
        testId={DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_NEXT}
        onClick={onNext}
      />
    </div>
  );
}
